/**
 * This file exposes the core functionality of the WDH architecture
 */
import WDHComponent from './src/js/wdh-component';
import WDHVariation from './src/js/wdh-variation';
import WDHSitecoreHelper from './src/js/wdh-sitecore-helper';
export { WDHComponent, WDHVariation, WDHSitecoreHelper };
export * from './src/js/_wdh';
export * from './src/js/layout/wdh-equal-height';